import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from "react";
import Grow from "@mui/material/Grow";
import Alert from "@mui/material/Alert";
import useNotify from ".";
import styles from "./styles.module.scss";
var ICONS = {
  info: false
};
function Notification() {
  var _useNotify = useNotify(),
    cache = _useNotify.cache,
    close = _useNotify.close;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.notifications
  }, cache.map(function (_ref) {
    var severity = _ref.severity,
      text = _ref.message.text,
      id = _ref.id,
      hide = _ref.hide;
    return /*#__PURE__*/React.createElement(Grow, {
      "in": !hide,
      key: id
    }, /*#__PURE__*/React.createElement("div", {
      "aria-live": "polite",
      "aria-atomic": "true",
      "aria-relevant": "additions",
      role: "region"
    }, /*#__PURE__*/React.createElement(Alert, _extends({
      className: "".concat(styles.notification, " ").concat(severity),
      "data-cy": "toaster-notification"
    }, ICONS[severity] !== undefined ? {
      icon: ICONS[severity]
    } : {}, {
      severity: severity,
      onClose: function onClose() {
        return close(id);
      }
    }), text)));
  }));
}
export default Notification;